import clsx from "clsx";
import { useEffect, useRef, useState } from "react";

export default function Glossary({ glossaryData }) {
  if (!glossaryData) return <></>;

  const [activeSection, setActiveSection] = useState(null);
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        root: null,
        // 80px top margin to offset the scroll-margin on the sections
        rootMargin: "80px 0px -70%",
        threshold: 0,
      }
    );
    Object.values(sectionRefs.current).forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      if (observer) {
        Object.values(sectionRefs.current).forEach((section) => {
          if (section) observer.unobserve(section);
        });
      }
    };
  }, []);

  return (
    <div className="glossary__content">
      <div className="glossary__list">
        {glossaryData.sections
          .filter((section) => section.terms.length > 0)
          .map((section, index) => {
            return (
              <div key={section.name}>
                {index > 0 && <div className="divider"></div>}
                <div
                  id={section.name}
                  ref={(el) => (sectionRefs.current[section.name] = el)}
                  className="glossary__section"
                >
                  <h2>{section.name}</h2>
                  <div>
                    {section.terms.map((term, index) => {
                      return (
                        <div
                          key={index}
                          id={term.anchor}
                          {...(term.anchor ? { id: term.anchor } : {})}
                          className="glossary__term"
                        >
                          <h3>{term.name}</h3>
                          <p dangerouslySetInnerHTML={{__html: term.description}}></p>
                          {term.href && <a href={term.href}>{term.linkText}</a>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="glossary__menu">
        {glossaryData.sections.map((section) => {
          return (
            <a
              key={section.name}
              href={`#${section.name}`}
              className={clsx(
                "glossary__menu-item",
                section.terms.length === 0 && "glossary__menu-item--disabled",
                activeSection === section.name && "glossary__menu-item--active"
              )}
            >
              {section.name}
            </a>
          );
        })}
      </div>
    </div>
  );
}
